// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__qNm33","heading":"style_heading__105_E","content":"style_content__iq_qS","button":"style_button__3AuYT","two_buttons":"style_two_buttons__1tiJS"};